import React, { useContext } from "react";
import cx from "classnames";
import { useAuth } from "shared-auth";
import NavThemeContext, { ThemeContextValues } from "../NavThemeContext";

interface Props {
  img?: string;
  className?: string;
}

const Avatar = ({ img, className }: Props) => {
  const theme = useContext(NavThemeContext);
  const auth = useAuth();
  const initials = `${auth.user?.profile.given_name?.[0] || ""}${auth.user?.profile.family_name?.[0] || ""}`;
  const avatarClassName = cx(
    "bg-color-neutral-three w-full h-full rounded-full flex items-center",
    "font-secondary justify-center border-2 text-s",
    {
      "border-color-user-cd text-color-user-cd":
        theme === ThemeContextValues.Cd,
      "border-color-user-agent text-color-user-agent":
        theme === ThemeContextValues.Agent,
      "border-color-user-performer text-color-user-performer":
        theme === ThemeContextValues.Performer,
      "border-color-user-filmmakers text-color-user-filmmakers":
        theme === ThemeContextValues.Filmmakers,
      "border-color-neutral-two text-color-neutral-two":
        theme === ThemeContextValues.Default,
    },
    className
  );

  return (
    <div className={avatarClassName}>
      {img ? (
        <img
          src={img}
          alt="avatar"
          className="h-full w-full rounded-full object-cover"
        />
      ) : (
        initials
      )}
    </div>
  );
};

export default Avatar;
